import type { Gradient, Look, Pattern, PatternId } from './types';

/** Ready-made gradients (the editor also accepts custom colors and an angle). */
export const GRADIENT_PRESETS: readonly Gradient[] = [
  { start: '#0079bf', end: '#2b7ab0', angle: 135 },
  { start: '#519839', end: '#b3d96b', angle: 135 },
  { start: '#d29034', end: '#f2d600', angle: 135 },
  { start: '#d4623f', end: '#ff9f1a', angle: 135 },
  { start: '#a874c4', end: '#ff78cb', angle: 135 },
  { start: '#00aecc', end: '#51e898', angle: 135 },
  { start: '#344563', end: '#6b778c', angle: 160 },
  { start: '#172b4d', end: '#0079bf', angle: 200 },
];

export const DEFAULT_PATTERN: Pattern = {
  id: 'dots',
  color: '#344563',
  background: null,
  opacity: 0.25,
  scale: 1,
};

export function patternOf(id: PatternId, color: string): Pattern {
  return { ...DEFAULT_PATTERN, id, color };
}

export const STANDARD_LOOK: Look = {
  v: 1,
  style: 'standard',
  one_color: true,
  color: null,
  advanced: null,
  gradient: null,
  pattern: null,
};

/** Angles offered by the gradient editor's direction buttons. */
export const GRADIENT_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315] as const;
